import React, { useEffect, useState } from 'react';
import { TableNew, Input, Button } from 'RooV1.12';
import request from '@/utils/request';
import { Pagination, Toast } from '@roo/roo';
import { ALIGN_TYPES } from '../../types';
import './index.scss';

interface IProps {
    wmPoiId: number;
    handleBind;
    type: string;
    setDistributeStatus?;
}

const DistributeList: React.FC<IProps> = (props: IProps) => {
    const { wmPoiId, handleBind, type, setDistributeStatus } = props;

    // 分页
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    // 员工列表数据
    const [staffList, setStaffList] = useState<urls.distribute.StaffDetail[]>([]);
    const [searchValue, setSearchValue] = useState();
    // 分配或者重新分配
    const urlMap = {
        distribute: '/api/thirdpartnar/poi/distribution/distribute',
        redistribute: '/api/thirdpartnar/poi/distribution/redistribute',
    };

    // 列表项
    const columns = [
        {
            title: <span className="list-header">员工账号</span>,
            dataIndex: 'acctLogin',
            align: ALIGN_TYPES.LEFT,
            width: 40,
            render(acctLogin: any) {
                return <span className="list-content">{acctLogin}</span>;
            },
        },
        {
            title: <span className="list-header">员工姓名</span>,
            dataIndex: 'staffName',
            align: ALIGN_TYPES.LEFT,
            width: 40,
            render(staffName: any) {
                return <span className="list-content">{staffName}</span>;
            },
        },
        {
            title: <span className="list-header">操作</span>,
            align: ALIGN_TYPES.CENTER,
            dataIndex: 'operate',
            width: 20,
            render(operate: any, record: any) {
                return (
                    <span
                        onClick={() => {
                            bindStaff(record.acctId);
                        }}
                        className="list-cotent-operate"
                    >
                        绑定
                    </span>
                );
            },
        },
    ];

    // 运营人绑定
    const bindStaff = (acctId: number) => {
        request
            .post(urlMap[type], {
                staffAcctId: acctId,
                wmPoiId: wmPoiId,
            })
            .then((res: urls.serverBase<any>) => {
                handleBind(true);
                setDistributeStatus(acctId);
                Toast.open({
                    status: 'success',
                    position: 'center',
                    children: '绑定成功',
                    duration: 2000,
                    theme: 'light',
                });
            })
            .catch(error => {
                console.error(error);
            });
    };

    // 获取员工列表
    const getStaffList = (searchVal?: string) => {
        request
            .get('/api/staff/list', {
                loginOrName: searchVal,
                pageNum: pageNum,
                pageSize: pageSize,
                status: '1', // 区分门店分配调用
            })
            .then((res: urls.serverBase<urls.distribute.StaffList>) => {
                const { total, staffs } = res.data;
                setTotal(total);
                setStaffList(staffs);
            })
            .catch(error => {
                console.error(error);
            });
    };

    useEffect(() => {
        getStaffList();
    }, [pageNum, pageSize]);

    return (
        <div className="operation-wrapper">
            <span className="operation-search">
                <Input
                    className="input-search"
                    size="normal"
                    styleType="plaintext"
                    placeholder="请输员工账号或姓名"
                    onPressEnter={() => {
                        getStaffList(searchValue);
                    }}
                    onChange={e => {
                        setSearchValue(e.target.value);
                    }}
                />
                <Button
                    onClick={() => {
                        getStaffList(searchValue);
                    }}
                >
                    搜索
                </Button>
            </span>
            <TableNew columns={columns} data={staffList} bordered />
            <div className="operation-pagination-right">
                <Pagination
                    total={total}
                    currentPage={pageNum}
                    pageSize={pageSize}
                    onChange={pageNum => setPageNum(pageNum)}
                />
            </div>
        </div>
    );
};

export default DistributeList;
